/**
 * Дизайн-токены интерфейса кладовщика (тема «Светлый голубой»).
 *
 * Зеркало admin/src/theme/tokens.js — админка и кладовщик собираются как два
 * разных приложения, общего импорта между ними нет. Значения ds менять только
 * вместе с админкой, иначе интерфейсы разъедутся.
 */
export const ds = {
  bg: "#eef4fb",
  surface: "#ffffff",
  surface2: "#f6f9fe",
  surface3: "#eef4fd",
  border: "#dbe5f3",
  border2: "#c5d6ee",

  text: "#0f2340",
  text2: "#4a5d7a",
  text3: "#8597b1",

  primary: "#2563eb",
  primaryHover: "#1d4fd8",
  primaryActive: "#1a45bd",
  primarySoft: "#e8f0fe",
  primarySoft2: "#d5e3fd",

  success: "#16a34a",
  successSoft: "#e6f6ec",
  warning: "#d97706",
  warningSoft: "#fdf2e1",
  danger: "#dc2626",
  dangerSoft: "#fdecec",
  dangerSoft2: "#fbdcdc",
  info: "#0284c7",
  infoSoft: "#e3f3fb",

  radiusSm: 6,
  radius: 10,
  radiusLg: 14,
  radiusXl: 18,

  shadowXs: "0 1px 2px rgba(15, 35, 64, 0.06)",
  shadowSm: "0 1px 3px rgba(15, 35, 64, 0.06), 0 2px 8px rgba(37, 99, 235, 0.06)",
  shadowMd: "0 4px 14px rgba(37, 99, 235, 0.10), 0 2px 6px rgba(15, 35, 64, 0.05)",
  shadowLg: "0 18px 48px rgba(37, 99, 235, 0.16), 0 6px 18px rgba(15, 35, 64, 0.08)",

  focusRing: "0 0 0 3px rgba(37, 99, 235, 0.22)",
  backdrop: "rgba(15, 35, 64, 0.32)",

  mp: {
    wb: "#a73afd",
    ozon: "#005bff",
    ym: "#fc3f1d",
  },
  mpSoft: {
    wb: "#f4e9ff",
    ozon: "#e6eeff",
    ym: "#ffece8",
  },
};

/**
 * Статусные цвета для МЕЛКОГО текста (11–13 px) на светлом фоне.
 * Базовые ds.success / ds.warning / ds.info на белом дают контраст около 3:1 —
 * для подписей этого мало, поэтому текст берём на тон темнее. Заливки и рамки
 * при этом остаются токенными (ds.successSoft + ds.success и т. д.).
 */
export const dsText = {
  success: "#15803d",
  warning: "#b45309",
  danger: "#b91c1c",
  info: "#0369a1",
  wb: "#7c3aed",
  ozon: "#1d4fd8",
  ym: "#c2410c",
};

/** Превью камеры: кадр остаётся тёмным, подложка и текст ошибки — под него. */
export const camera = {
  bg: "#0b1626",
  overlay: "rgba(15, 35, 64, 0.82)",
  errorText: "#fecaca",
};

/** Градиент бокового меню админки — в кладовщике это верхняя полоса. */
export const sidebarGradient =
  "linear-gradient(165deg, #f8fbff 0%, #e8f3fc 38%, #dceeff 72%, #cfe4fa 100%)";
export const sidebarBorder = "rgba(37, 99, 235, 0.14)";

/** Минимальная цель нажатия: экран рабочий, телефон в одной руке, сканер в другой. */
export const TAP = 48;

export const fontFamily =
  '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
